export default function StudentVisaInAustralia() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-8">
                
                {/* H2 */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Types of Student Visas in Australia
                </h3>

                {/* Intro Paragraph */}
                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Australia offers several visa options for international students based on the 
                        type of course, study duration, and future career plans. Below are the main 
                        Australian visa categories relevant to students and graduates:
                    </p>
                </div>

                {/* Subclass 500 */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Student Visa (Subclass 500):
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        The Subclass 500 visa is the primary student visa for international students 
                        enrolled in full-time courses at registered Australian institutions. 
                        It allows students to stay in Australia for the duration of their course, 
                        work part-time during study periods, and work full-time during scheduled breaks.
                    </p>
                </div>

                {/* Subclass 590 */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Student Guardian Visa (Subclass 590):
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        The Subclass 590 visa is designed for parents or legal guardians who wish to 
                        accompany and support international students under 18 years of age while 
                        they study in Australia.
                    </p>
                </div>

                {/* Subclass 491 */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Skilled Work Regional (Provisional) Visa (Subclass 491):
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        Although not a student visa, the Subclass 491 visa allows skilled individuals 
                        to live, work, and study in designated regional areas of Australia for up to 
                        five years. This visa can potentially lead to permanent residency.
                    </p>
                </div>

                {/* Subclass 407 */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Training Visa (Subclass 407):
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        The Subclass 407 Training Visa enables individuals to participate in 
                        occupational training or professional development programs in Australia. 
                        It is ideal for those looking to enhance skills related to their field of study or profession.
                    </p>
                </div>

                {/* Subclass 485 */}
                <h4 className="text-xl sm:text-xl lg:text-2xl font-bold text-gray-900">
                    Temporary Graduate Visa (Subclass 485):
                </h4>

                <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg lg:text-xxl leading-relaxed">
                    <p>
                        The Subclass 485 visa allows international students who have completed 
                        an eligible Australian qualification to stay and work in Australia temporarily. 
                        It provides valuable post-study work experience aligned with their field of study.
                    </p>
                </div>

            </div>
        </section>
    );
}